import { render, staticRenderFns } from "./cangchuRkPup.vue?vue&type=template&id=dace0bf4&scoped=true&"
import script from "./cangchuRkPup.vue?vue&type=script&lang=js&"
export * from "./cangchuRkPup.vue?vue&type=script&lang=js&"
import style0 from "./cangchuRkPup.vue?vue&type=style&index=0&id=dace0bf4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dace0bf4",
  null
  
)

export default component.exports